function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NewZealandFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2129",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2129)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2129",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2129)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask2_621_2129",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "14",
        height: "11",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "13.5",
          height: "10.5",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_2129)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.50317 12.7499L1.46754 14.0528L13.5674 4.41657L15.1344 2.48042L11.9577 2.04496L7.02241 6.19747L3.05003 8.9953L-1.50317 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.0965 13.6627L0.416945 14.4188L14.5717 2.30052H12.4467L-1.0965 13.6627Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.0032 12.7499L12.0325 14.0528L-0.0673752 4.41657L-1.63436 2.48042L1.54239 2.04496L6.47765 6.19747L10.45 8.9953L15.0032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9019 13.405L13.3884 14.1611L7.36117 8.9726L5.57422 8.39291L-1.78515 2.48701H0.339895L7.69513 8.25273L9.64885 8.94784L14.9019 13.405Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "path-9-outside-1_621_2129",
          maskUnits: "userSpaceOnUse",
          x: "-1",
          y: "2",
          width: "16",
          height: "13",
          fill: "black",
          children: [/*#__PURE__*/_jsx("rect", {
            fill: "white",
            x: "-1",
            y: "2",
            width: "16",
            height: "13"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
          fill: "#F7FCFF",
          mask: "url(#path-9-outside-1_621_2129)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6399 18.375L17.3174 19.0703L17.5699 17.5976L16.5 16.5547L17.9786 16.3399L18.6399 15L19.3011 16.3399L20.7798 16.5547L19.7098 17.5976L19.9624 19.0703L18.6399 18.375Z",
        fill: "#F50100",
        stroke: "#F7FCFF",
        strokeWidth: "0.35"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9 13.4024L14.8802 13.9385L15.075 12.803L14.25 11.9988L15.3901 11.8332L15.9 10.8L16.4099 11.8332L17.55 11.9988L16.725 12.803L16.9198 13.9385L15.9 13.4024Z",
        fill: "#F50100",
        stroke: "#F7FCFF",
        strokeWidth: "0.35"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.1482 13.3995L20.1295 13.935L20.3241 12.8008L19.5 11.9975L20.6389 11.832L21.1482 10.8L21.6575 11.832L22.7963 11.9975L21.9722 12.8008L22.1668 13.935L21.1482 13.3995Z",
        fill: "#F50100",
        stroke: "#F7FCFF",
        strokeWidth: "0.35"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.9 9.20238L17.8802 9.73849L18.075 8.60298L17.25 7.7988L18.3901 7.63313L18.9 6.60001L19.4099 7.63313L20.55 7.7988L19.725 8.60298L19.9198 9.73849L18.9 9.20238Z",
        fill: "#F50100",
        stroke: "#F7FCFF",
        strokeWidth: "0.35"
      })]
    })]
  })]
}));
//# sourceMappingURL=NewZealand.js.map